import React, { Component } from 'react';
import Tone from 'tone/Tone'
import Button from '@material-ui/core/Button'
import VolumeUpIcon from '@material-ui/icons/VolumeUp';

class ChordPlayer extends Component {

    constructor() {
        super()
        this.onPlayButtonClick = this.onPlayButtonClick.bind(this)
        this.getTones = this.getTones.bind(this)
    }

    render() {
        this.tones = this.getTones()
        return (
            <Button variant="contained" color="primary" onClick={this.onPlayButtonClick}>
                Play
                <VolumeUpIcon/>
            </Button>
        )
    }

    onPlayButtonClick() {
        if (this.synth == null) {
            console.log('build synth!')
            this.synth = this.makeSynth()
        }

        this.synth.triggerAttackRelease(this.tones, 1)
        
    }

    makeSynth() {
        var synth = new Tone.PolySynth(8, Tone.Synth)
        
        synth.set({
            oscillator: {
              type: 'square8'
            },
            envelope: {
              attack: 2,
              decay: 1,
              sustain: 0.4,
              release: 4
            }
        })
        
        return synth.toMaster()
    }

    getTones() {
        var tones = []

        for(var i=0; i < this.props.chord.keys.length; i++) {
            if (this.props.chord.keys[i] === 1) {
                tones.push(this.props.keyTones[i])
            }
        }

        return tones
    }
}

export default ChordPlayer;


// WEBPACK FOOTER //
// ./src/ChordPlayer.js